export default function initCart() {
    function triggerCartFormSubmit() {
        const form = document.querySelector('.cart-form-wrapper form');
        if (form) {
            form.classList.add('loading');
            form.submit();
        }
    }

    // Automatically submit the cart form on change in input or select elements
    document.body.addEventListener('change', function(event) {
        if (event.target.matches('.cart-form-wrapper form input, .cart-form-wrapper form select')) {
            console.log('Auto-submit triggered by change event');
            triggerCartFormSubmit();
        }
    });

    // Code for spinner value increment/decrement
    document.body.addEventListener('click', function(event) {
        if (event.target.matches('.quantity-field-holder .quantity-up')) {
            const spinner = getSpinner(event);
            let value = parseInt(spinner.value, 10);
            const max = spinner.getAttribute('max');

            if (max !== null) {
                value = Math.min(value + 1, parseInt(max, 10));
            } else {
                value += 1;
            }
            spinner.value = value;
            triggerCartFormSubmit();
        }

        if (event.target.matches('.quantity-field-holder .quantity-down')) {
            const spinner = getSpinner(event);
            const value = Math.max(parseInt(spinner.value, 10) - 1, 0);
            spinner.value = value;
            triggerCartFormSubmit();
        }
    });

    function getSpinner(event) {
        return event.target.closest('.quantity-field-holder').querySelector('input');
    }

    // Set placeholder for the phone number field if it exists
    const internationalPhoneNumberField = document.getElementById('PaymentForm_OrderForm_Nobrainer-SilvershopBase-Checkout-CustomCustomerDetailsComponent_Phone');
    if (internationalPhoneNumberField) {
        internationalPhoneNumberField.setAttribute('placeholder', '+45 00 00 00 00');
    }
}
